import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useId } from '../../Utils/Hooks';
import { Popover } from '../Popover';

import * as Styles from './index.styles';

const {
    StyledWrapper,
    StyledLabel,
    StyledInput,
    StyledText,
    StyledHelperContainer,
    StyledInputContainer,
} = Styles;

export const DisplayInput = ({
    id,
    label,
    message,
    error,
    disabled,
    value,
    onChange,
    placeholder,
    helperContent,
    inputRef,
    singleSize,
    icon,
    iconLeft,
    ...otherProps
}) => {
    const [open, setOpen] = useState(false);

    const ref = inputRef || useRef();

    const [rawInputId] = useId('input', id);

    return (
        <StyledWrapper singleSize={singleSize}>
            <StyledLabel disabled={disabled}>
                {label}
                {helperContent && !disabled && (
                    <StyledHelperContainer
                        id={`display-input-helper-button${rawInputId}`}
                        data-test-id="help-btn"
                        onClick={() => setOpen(prev => !prev)}
                    >
                        <FontAwesomeIcon icon={['fas', 'info']} />
                    </StyledHelperContainer>
                )}
            </StyledLabel>
            <StyledInputContainer>
                {iconLeft}
                <StyledInput
                    id={rawInputId}
                    type="text"
                    autoComplete="off"
                    ref={ref}
                    disabled={disabled}
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder}
                    {...otherProps}
                />
                {icon}
            </StyledInputContainer>
            {message && (
                <StyledText small error={error}>
                    {message}
                </StyledText>
            )}
            {helperContent && (
                <Popover
                    bindTo={`display-input-helper-button${rawInputId}`}
                    open={!disabled && open}
                    onClose={() => setOpen(false)}
                    enableMobile
                    darkMode
                >
                    <div data-test-id="help-content">{helperContent}</div>
                </Popover>
            )}
        </StyledWrapper>
    );
};

DisplayInput.propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    message: PropTypes.string,
    error: PropTypes.bool,
    disabled: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    helperContent: PropTypes.node,
    inputRef: PropTypes.shape({}),
    singleSize: PropTypes.bool,
    icon: PropTypes.node,
    iconLeft: PropTypes.node,
};

DisplayInput.defaultProps = {
    id: '',
    label: '',
    message: '',
    error: false,
    disabled: false,
    value: undefined,
    onChange: () => {},
    placeholder: '',
    helperContent: '',
    inputRef: null,
    singleSize: false,
    icon: undefined,
    iconLeft: undefined,
};

DisplayInput.Styles = Styles;

export default DisplayInput;
